import { DotMark } from '@carbon/react/icons';
import style from './status-indicator.module.scss';
import classNames from 'classnames';
import { FC, ReactNode } from 'react';

interface Props {
  state: 'notConfirmed' | 'confirmed' | boolean;
  title?: string;
  children?: ReactNode;
}

const StatusIndicator: FC<Props> = ({ state, children, title }) => {
  return (
    <span title={title} className={style.statusIndicator}>
      {state && (
        <DotMark
          className={classNames(style.statusIndicatorIcon, {
            [style.confirmed]: state === 'confirmed',
          })}
        />
      )}
      {children}
    </span>
  );
};

export { StatusIndicator };
